export const defaultErrorMessage =
  'Something went wrong. Please try it again or report it to engineering team.';
